/* Strip private transfer identifiers and OAuth codes before analytics loads. */
(() => {
  const url = new URL(location.href);
  if (url.pathname !== '/pages/binder') return;
  const incoming = {};
  if (url.hash.startsWith('#kb=')) {
    try { incoming.transfer = decodeURIComponent(url.hash.slice(4)); } catch (_) {}
    url.hash = '';
  }
  if (url.searchParams.has('code') || url.searchParams.has('error')) {
    incoming.callback = {};
    for (const key of ['code', 'state', 'error', 'error_description']) {
      incoming.callback[key] = url.searchParams.get(key);
      url.searchParams.delete(key);
    }
    try {
      const transaction = JSON.parse(sessionStorage.getItem('killin-binder-account-login-v1') || 'null');
      if (transaction?.state === incoming.callback.state && transaction.preview !== false) url.searchParams.set('builder_preview', '1');
    } catch (_) {}
  }
  if (Object.keys(incoming).length) {
    window.KillinBinderIncoming = incoming;
    url.searchParams.set('mode', 'builder');
    history.replaceState(null, '', url);
  }
})();
